<template>
  <div class="h-8 rounded-lg bg-gray-100 flex items-center relative pointer-events-auto">
    <input class="w-full h-full border-none pr-8 pl-4 bg-transparent text-sm"
           :placeholder="$t('common.search')"
           ref="search"
           :value="value"
           @input="$emit('input', $event.target.value)"
           @keydown.esc="$emit('clear')"
    />
    <GrmResetBtn class="absolute right-1"
                 @click="$emit('clear')"
    />
  </div>
</template>

<script>
import GrmResetBtn from '@/components/Common/button/GrmResetBtn';

export default {
  name: 'GrmSearch',
  components: {
    GrmResetBtn,
  },
  props: {
    value: { type: String,  default: '' },
  },
}
</script>

<style lang="scss" scoped></style>